import { useFeatureFlags } from 'feature-flags';

export const useVideoDownloadPermission = () => {
  const { REDACT_PII_VIDEO_DOWNLOAD } = useFeatureFlags(['REDACT_PII_VIDEO_DOWNLOAD']);

  return {
    isDisableVideoDownload: !!REDACT_PII_VIDEO_DOWNLOAD,
  };
};
